export const FIND_EMPLOYEE_REQUEST = 'FIND_EMPLOYEE_REQUEST';

export const findEmployeeRequest = ( id ) => ({
    type: FIND_EMPLOYEE_REQUEST,
    payload: { id }
});
